import React from "react";
import { Box, Grid } from "@mui/material";
import Dashboard from "../components/Dashboard/Dashboard";
const ClientAdminDashboard = () => {
  return (
    <>
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        sx={{ background: "#f4f4f4" }}
      >
        <Grid item xs={12} md={12}>
          <Box
            sx={{
              bgcolor: "#f2f2f2",
              height: { xs: "auto", sm: "100%" },
              border: "1px solid #d1cfcf",
              borderRadius: "5px",
              padding: "16px 0px",
            }}
          >
            <Dashboard />
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
export default ClientAdminDashboard;
